import {
  createRouter,
  // createWebHashHistory,
  RouteRecordRaw,
  createWebHistory,
} from "vue-router";
import { createStore } from '@/vuex/store';
import { ElMessage } from "element-plus";
// import { getRouterName } from '@/utils/utils';
import authMenu from '@/common/menuList.json';

import i18n from '@/locales/i18n';
// import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "portal",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/portal/pLayout_new.vue"),
    redirect: "/console/agents",
    children: [
      {
        path: "/portal",
        name: "portals",
        component: () => import("@/views/portal/pLayout_new.vue"),
        redirect: "/console/agents",
        children:[]
      },
    ],
  },
  {
    path: "/portalNew",
    name: "portalNew",
    redirect: "/console/agents",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/portal/pLayout_new.vue"),
    children: [
      {
        path: "/portalNew",
        name: "portalNews",
        component: () => import("@/views/portal/pLayout_new.vue"),
        redirect: "/console/agents",
        children:[]
      },
    ],
  },
  {
    path: "/home",
    name: "home",
    redirect: "/home",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/HomeView/index.vue"),
    children: [
      {
        path: "/home",
        name: "HomeAll",
        component: () => import("@/views/HomeAll.vue"),
      },
      {
        path: "/square",
        name: "square",
        component: () => import("@/views/Square.vue"),
      },
      {
        path: "/app/:code",
        name: "app",
        component: () => import("@/views/HomeView/ChatView/index.vue"),
      },
      {
        path: "/paint",
        name: "paintPic",
        component: () => import("@/views/PaintPic.vue"),
      },
      {
        path: "/templates",
        name: "template",
        component: () => import("@/views/console/TemplateCenter/index.vue"),
      },
      {
        path: "/template/:code",
        name: "templateCode",
        component: () => import("@/views/console/TemplateCenter/TemplateChat.vue"),
      },
    ],
  },
  {
    path: "/console",
    name: "console",
    redirect: "/console/agents",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/console/index.vue"),
    children: [
      {
        path: "/console/agents",
        name: "myApp",
        component: () => import("@/views/console/MyApp/index.vue"),
        meta: {
          showPath: '/console/agents',
          tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.app'),
          titleName: i18n.global.t('router18.app')
        }
      },
      {
        path: "/console/Integrations",
        name: "openInterface",
        component: () => import("@/views/console/AppInterface/OpenInterface.vue"),
        meta: {
          showPath: '/console/Integrations',
          tabName: '/ ' + i18n.global.t('router18.interface') + ' / ' + i18n.global.t('router18.openInterface'),
          titleName: i18n.global.t('router18.openInterface')
        }
      },
      // {
      //   path: "/console/dataAnalysis",
      //   name: "dataAnalysis",
      //   component: () => import("@/views/console/DataAnalysis.vue"),
      //   meta: {
      //     showPath: '/console/dataAnalysis',
      //     tabName: '/管理/数据看板'
      //   }
      // },

      {
        path: "/console/createApp",
        name: "createApp",
        component: () => import("@/views/console/CreateApp.vue"),
        meta: {
          showPath: '/console/agents',
          tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.app') + ' / ' + i18n.global.t('router18.createApp'),
          titleName: i18n.global.t('router18.app')
        }
      },
      {
        path: "/console/agent",
        name: "EmbeddingApp",
        component: () =>
          import("@/views/console/EmbeddingApp/index.vue"),
        meta: {
          showPath: '/console/agents',
          tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.app') + ' / ' + i18n.global.t('router18.agent'),
          titleName: i18n.global.t('router18.app')
        }
      },

      {
        path: "/console/account",
        name: "myCenter",

        component: () => import("@/views/console/myCenter/MyCenter.vue"),
        meta: {
          showPath: '/console/account',
          tabName: '/ ' + i18n.global.t('router18.manage') + ' / ' + i18n.global.t('router18.myAccount'),
          titleName: i18n.global.t('router18.myAccount')
        }
      },


      {
        path: "/console/chatManage",
        name: "chatManage",
        component: () => import("@/views/console/ChatManage.vue"),
        meta: {
          showPath: '/console/chatManage',
          tabName: '/ ' + i18n.global.t('router18.interface') + ' / ' + i18n.global.t('router18.chatManage'),
          titleName: i18n.global.t('router18.chatManage')
        }
      },
      // {
      //   path: "/console/ChatIphone",
      //   name: "chatManage",
      //   component: () => import("@/views/console/ChatIphone.vue"),
      // },
      {
        path: "/console/clients",
        name: "clients",
        component: () => import("@/views/console/Clients/ClientsList.vue"),
        meta: {
          showPath: '/console/clients',
          tabName:'/ ' + i18n.global.t('router18.interface') + '/ ' + i18n.global.t('router18.clients'),
          titleName: i18n.global.t('router18.clients')
        }
      },
      {
        path: "/console/analysis",
        name: "dataAnalysis",
        component: () => import("@/views/console/DataAnalysis/index.vue"),
        meta: {
          showPath: '/console/analysis',
          tabName: '/ ' + i18n.global.t('router18.manage') + ' / ' + i18n.global.t('router18.dataAnalysis'),
          titleName: i18n.global.t('router18.dataAnalysis')
        }
      },
      {
        path: "/console/clients/configClient",
        name: "configurationClient",
        component: () => import("@/views/console/Clients/ConfigurationClient.vue"),
        meta: {
          showPath: '/console/clients',
          tabName: '/ ' + i18n.global.t('router18.interface') + '/ ' + i18n.global.t('router18.clients') + ' / ' + i18n.global.t('router18.configurationClient'),
          titleName: i18n.global.t('router18.clients')
        }
      },
      {
        path: "/console/clients/config",
        name: "configurationClientChat",
        component: () => import("@/views/console/Clients/ConfigurationClientChat.vue"),
        meta: {
          showPath: '/console/clients',
          tabName: '/ ' + i18n.global.t('router18.interface') + '/ ' + i18n.global.t('router18.clients') + ' / ' + i18n.global.t('router18.configurationClient'),
          titleName: i18n.global.t('router18.clients')
        }
      },
      {
        path: "/console/knowledge",
        name: "knowledgeBase",
        component: () => import("@/views/console/KnowledgeBase/KnowledgeBase.vue"),
        meta: {
          showPath: '/console/knowledge',
          tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.knowledgeBase'),
          titleName: i18n.global.t('router18.knowledgeBase')
        }
      },
      {
        path: "/console/knowledge/knowledgeManage",
        name: "KnowledgeManage",

        component: () => import("@/views/console/KnowledgeBase/KnowledgeManage.vue"),
        redirect: "/console/knowledge/baseAll",
        children: [{
          path: "/console/knowledge/baseAll",
          name: "baseAll",

          component: () => import("@/views/console/KnowledgeBase/BaseAll.vue"),
          meta: {
            showPath: '/console/knowledge',
            tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.knowledgeBase') + ' / ' + i18n.global.t('router18.fileManage'),
            titleName: i18n.global.t('router18.knowledgeBase')
          }
        },
        {
          path: "/console/knowledge/baseFile",
          name: "baseFile",

          component: () => import("@/views/console/KnowledgeBase/BaseFile.vue"),
          meta: {
            showPath: '/console/knowledge',
            tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.knowledgeBase') + ' / ' + i18n.global.t('router18.fileManage'),
            titleName: i18n.global.t('router18.knowledgeBase')
          }
        },
        {
          path: "/console/knowledge/importFile",
          name: "importFile",

          component: () => import("@/views/console/KnowledgeBase/ImportFile.vue"),
          meta: {
            showPath: '/console/knowledge',
            tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.knowledgeBase') + ' / ' + i18n.global.t('router18.fileImport'),
            titleName: i18n.global.t('router18.knowledgeBase')
          }
        },
        {
          path: "/console/knowledge/retrievalFile",
          name: "retrievalFile",

          component: () => import("@/views/console/KnowledgeBase/RetrievalFile.vue"),
          meta: {
            showPath: '/console/knowledge',
            tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.knowledgeBase') + ' / ' + i18n.global.t('router18.retrievalTest'),
            titleName: i18n.global.t('router18.knowledgeBase')
          }
        },
        {
          path: "/console/knowledge/baseSetting",
          name: "baseSetting",

          component: () => import("@/views/console/KnowledgeBase/BaseSetting.vue"),
          meta: {
            showPath: '/console/knowledge',
            tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.knowledgeBase') + ' / ' + i18n.global.t('router18.knowledgeBaseConfig'),
            titleName: i18n.global.t('router18.knowledgeBase')
          }
        },
        {
          path: "/console/knowledge/mediaResource",
          name: "mediaResource",
          component: () => import("@/views/console/KnowledgeBase/MediaResource.vue"),
          meta: {
            showPath: '/console/knowledge',
            tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.knowledgeBase') + ' / ' + i18n.global.t('router18.mediaResource'),
            titleName: i18n.global.t('router18.knowledgeBase')
          }
        }]
      },
      {
        path: "/console/database",
        name: "database",
        component: () => import("@/views/console/DataBase/index.vue"),
        meta: {
          showPath: '/console/database',
          tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.database'),
          titleName: i18n.global.t('router18.database')
        }
      },
      {
        path: "/console/database/navigation",
        name: "databaseNavigation",
        component: () => import("@/views/console/DataBase/databaseNavigation.vue"),
        redirect: "/console/database/databaseNavigation/preview",
        children: [{
          path: "/console/database/preview",
          name: "databasePreview",
          component: () => import("@/views/console/DataBase/databasePreview.vue"),
          meta: {
            showPath: '/console/database',
            tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.database') + ' / ' + i18n.global.t('router18.dataPreview'),
            titleName: i18n.global.t('router18.database')
          }
        }, {
          path: "/console/database/tableConfig",
          name: "tableConfig",
          component: () => import("@/views/console/DataBase/tableConfig.vue"),
          meta: {
            showPath: '/console/database',
            tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.database') + ' / ' + i18n.global.t('router18.tableConfig'),
            titleName: i18n.global.t('router18.database')
          }
        }, {
          path: "/console/database/databaseConfig",
          name: "databaseConfig",
          component: () => import("@/views/console/DataBase/databaseConfig.vue"),
          meta: {
            showPath: '/console/database',
            tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.database') + ' / ' + i18n.global.t('router18.databaseConfig'),
            titleName: i18n.global.t('router18.database')
          }
        },
        ]
      },
      {
        path: "/console/plugins",
        name: "plugins",
        component: () => import("@/views/console/PluginAll.vue"),
        meta: {
          showPath: '/console/plugins',
          tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.plugins'),
          titleName: i18n.global.t('router18.plugins')
        }
      },
      {
        path: "/console/templates",
        name: "templateCenter",
        component: () => import("@/views/console/TemplateCenter/index.vue"),
        meta: {
          showPath: '/console/templates',
          tabName: '/ ' + i18n.global.t('router18.discovery') + ' / ' + i18n.global.t('router18.templateCenter'),
          titleName: i18n.global.t('router18.templateCenter')
        }
      },
      {
        path: "/console/template/:code",
        name: "templateChat",
        component: () => import("@/views/console/TemplateCenter/TemplateChat.vue"),
        meta: {
          showPath: '/console/templates',
          tabName: '/ ' + i18n.global.t('router18.discovery') + ' / ' + i18n.global.t('router18.templateCenter') + ' / ' + i18n.global.t('router18.templateDetail'),
          titleName: i18n.global.t('router18.templateCenter')
        }
      },
      {
        path: "/console/workflows",
        name: "flow",
        component: () => import("@/views/console/FlowWork.vue"),
        meta: {
          showPath: '/console/workflows',
          tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.workflow'),
          titleName: i18n.global.t('router18.workflow')
        }
      },
      {
        path: "/console/plugins/detail",
        name: "customPlugin",
        component: () => import("@/views/console/PLuginManage/CustomPlugin.vue"),
        meta: {
          showPath: '/console/plugins',
          tabName: '/ ' + i18n.global.t('router18.create') + ' / ' + i18n.global.t('router18.plugins') + ' / ' + i18n.global.t('router18.customPlugin'),
          titleName: i18n.global.t('router18.plugins')
        }
      },
      {
        path: "/console/teamSpace",
        name: "teamSpace",
        component: () => import("@/views/console/TeamSpace/index.vue"),
        meta: {
          showPath: '/console/teamSpace',
          tabName: '/ ' + i18n.global.t('router18.manage') + ' / ' + i18n.global.t('router18.teamSpace'),
          titleName: i18n.global.t('router18.teamSpace')
        }
      },
      {
        path: "/console/teamSpace/roleEdit",
        name: "roleEdit",
        component: () => import("@/views/console/TeamSpace/RightTree.vue"),
        meta: {
          showPath: '/console/teamSpace',
          tabName: '/ ' + i18n.global.t('router18.manage') + ' / ' + i18n.global.t('router18.teamSpace'),
          titleName: i18n.global.t('router18.teamSpace')
        }
      },
      {
        path: "/console/price",
        name: "price",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/RechargeView.vue"),
        meta: {
          showPath: '/console/account',
          tabName: '/ ' + i18n.global.t('router18.purchase'),
          titleName: i18n.global.t('router18.purchase')
        }
      },
      {
        path: "/console/customManage",
        name: "customManage",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/console/CustomManage/index.vue"),
        redirect: "/console/customManage/customerList",
        children: [{
          path: "/console/customManage/customerList",
          name: "customerList",
          component: () => import("@/views/console/CustomManage/compoents/CustomerList.vue"),
          meta: {
            showPath: '/console/customManage',
            tabName: '/ ' + i18n.global.t('router18.interface') + ' / ' + i18n.global.t('router18.customerManage') + ' / ' + i18n.global.t('router18.customerList'),
            titleName: i18n.global.t('router18.customerManage')
          }
        }, {
          path: "/console/customManage/tagList",
          name: "tagList",
          component: () => import("@/views/console/CustomManage/compoents/TagList.vue"),
          meta: {
            showPath: '/console/customManage',
            tabName: '/ ' + i18n.global.t('router18.interface') + ' / ' + i18n.global.t('router18.customerManage') + ' / ' + i18n.global.t('router18.tagList'),
            titleName: i18n.global.t('router18.customerManage')
          }
        }]
      },
    ],
  },
  {
    path: '/pluginKey',
    name: "pluginKey",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/pluginKey.vue"),
  },
  {
    path: '/console/workflow',
    name: "addFlow",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/vueFlow/VueFlow.vue"),
  },
  {
    path: '/benefits',
    name: "inviteActivi",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/InviteActivi.vue"),
  },
  // {
  //   path: "/about",
  //   name: "about",
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "@/views/ChatView.vue"),
  // },
  {
    path: "/web/agent/:clientId",
    name: "web",
    component: () =>
      import("@/views/console/ibotManage/iframeChat.vue"),
  },
  {
    path: "/fillform",
    name: "fillform",
    component: () =>
      import("@/views/contectCustomer/LinkAiForm.vue"),
  },
  {
    path: "/web/iframe/:clientId",
    name: "fullweb",
    component: () =>
      import("@/views/console/ibotManage/iframeFullChat.vue"),
  },
  {
    path: "/:pathMatch(.*)",
    //访问主页的时候 重定向到index页面
    redirect: "/404",
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/Not404.vue"),
  },
  {
    path: "/iframe",
    name: "iframes",
    component: () => import("@/views/console/ibotManage/iframeTest.vue"),
  }
];
//router/index.js

const router = createRouter({
  scrollBehavior() {
    // 始终滚动到顶部
    return { top: 0 }
  },
  history: createWebHistory(),
  routes,
});


function findMenuByPath(menuList: any, path: any): any {
  for (const item of menuList) {
    // 检查当前项的路径
    if (item.path === path) {
      return item; // 找到匹配项
    }
    // 如果有子菜单，递归查找
    if (item.children) {
      const found = findMenuByPath(item.children, path);
      if (found) {
        return item; // 返回父菜单
      }
    }
  }
  return null; // 如果没有找到，返回 null
}
router.beforeEach((to: any, from, next) => {

  const store = createStore()
  const userDetail = store.state.user

  if (userDetail.authorizedRoute) {
    const allow = findMenuByPath(authMenu, to.path)
    try {
      if (allow.isAuthen && allow.isAuthen === 'Y') {
        const go = userDetail.authorizedRouteList.includes(allow.path)
        if (go) {
          next();
        } else {
          // ElMessage({
          //   type: 'warning',
          //   message: '暂无权限'
          // })
          next({ path: userDetail.authorizedRouteList[0] });
          return
        }
      } else {
        next()
      }
    } catch {
      next()
    }


    // console.log(7, userDetail.authorizedRouteList)
    // const a = getRouterName(userDetail.authorizedRouteList)

  } else {
    // if (to.name === 'clients' && store.state.userPrivige.clientManage < 1) {
    //   ElMessage({
    //     type: 'warning',
    //     message: '暂无权限'
    //   })
    //   return
    // }
    // if (to.name === 'chatManage' && store.state.userPrivige.customerManage < 1) {
    //   ElMessage({
    //     type: 'warning',
    //     message: '暂无权限'
    //   })
    //   return
    // }
    // if (to.name === 'teamSpace' && store.state.userPrivige.memberNumber < 1) {
    //   ElMessage({
    //     type: 'warning',
    //     message: '暂无权限'
    //   })
    //   return
    // }
    next();
  }

});
export default router;
